import { connect } from 'react-redux';

import geofences from 'APP_ROOT/data/geofences';
import settingsSelectors from 'APP_ROOT/data/settings/selectors';

import ZoneSize from './ZoneSize';

const mapStateToProps = (state, ownProps) => {
    return {
        radiusInKm: geofences.Selectors.geofenceRadiusInKm(state, ownProps.geofenceId),
        areaInKm2: geofences.Selectors.geofenceAreaInKm2(state, ownProps.geofenceId),
        radiusInKmStatus: geofences.Selectors.geofenceGeojsonChangePending(state, ownProps.geofenceId) ? 'PENDING' : '',
        unitOfMeasure: settingsSelectors.unitOfMeasure(state),
        geofenceType: geofences.Selectors.geofenceType(state, ownProps.geofenceId, true)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onChange: (radiusInKm) => dispatch(
            geofences.Actions.setGeofenceRadiusInKm('', ownProps.geofenceId, radiusInKm)
        )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZoneSize);
